import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';

import Timer from './Timer.react';

import Select from './Select.react';
import Release from './Release.react';
import ViewProfile from './ViewProfile.react';
import CheckoutButton from '../button/CheckoutButton.react';
// import ChangeStatus from '../pos/sidebar/ChangeStatus.react';

class Guest extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid(),
            loading : false
        };

        this.expanded = this.expanded.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.expanded();
    }

    componentWillReceiveProps(next) {
        this.expanded(next)
    }

    expanded(next) {
        var self = this;

        if (!this.state.loading)
            return;

        var expanded = false;
        var selected = next ? next.selected : this.props.selected;

        if (selected && selected.Guest_id === this.props.guest.Guest_id)
            expanded = true;

        $('#control_'+this.state.uuid).css({'height':(expanded ? '40px' : 0)})

    }

    onClick() {
        var self = this;

        var guest      = this.props.guest;
        var selected   = this.props.selected;
        var isSelected = selected && selected.Guest_id === guest.Guest_id ? true : false;

        this.setState({ loading : true }, () => {
            self.props.onClick(isSelected ? false : guest);
        });

    }

    render() {
        var guest      = this.props.guest;
        var user       = this.props.user; 
        var selected   = this.props.selected;
        var statusList = this.props.statusList;
        var selectedLocation = this.props.selectedLocation;
        var isSelected = selected && selected.Guest_id === guest.Guest_id ? true : false;
        var wholeSale  = selectedLocation.CompanyFlag !== 'Dispensary' ? true : false;
        var color = _.find(statusList, {POSStatus : guest.TransactionStatus}) || '#f2f2f2';

        if (color.hasOwnProperty('Color'))
            color = color.Color;

        var preOrderCnt = (guest.PreOrderCnt > 0) ? ' ('+guest.PreOrderCnt+')' : '';
        var lsp = UserStore.getState().user.LspId;
        var transactionReference = guest.TransactionReference || '';

        return (
            <div
                className='guest' id={this.state.uuid}>

                <div
                    className={'guest__info '+(isSelected ? 'guest__info--active' : '')}
                    onClick={this.onClick}
                    style={{'backgroundColor' : color}}>

                    <div className='guest__info--name'>
                        {guest.FullName}

                        { guest.nickname.length > 0 &&
                            <span className='guest__info--nickname'>
                                ({guest.nickname})
                            </span>
                        }

                        { selectedLocation.IndicateLoyaltyMember && guest.IsLoyaltyMember &&
                            <span className='guest__info--loyalty'>
                                LOYALTY MEMBER <img width='20' height='20' src='/assets/star.png' />
                            </span>
                        }
                    </div>
                    {!!guest.RemotePayTransactionId
                            && (
                                <div className='guest__info--remotePay'>
                                    RemotePay
                                </div>
                    )}  
                    {!!guest.IsPrePaid
                        && (
                            <div className='guest__info--remotePay'>
                                Pre-Paid
                            </div>
                        )
                    }                      
                    {
                        transactionReference.length > 0 && !wholeSale &&
                        <div className='guest__info--reference'>
                            REF #: {guest.TransactionReference}
                        </div>
                    }
                    <div>
                        { wholeSale ?
                            <div className='guest__info--id'>
                                <b>Title: {guest.ManifestTitle}</b>
                            </div>
                        :
                            <div className='guest__info--id'>
                                <b>MMJ ID:</b> {guest.MJStateIDNo}
                            </div>
                        }
                    </div>
                    <div className='guest__info--stats'>
                        { !wholeSale &&
                            <div className='guest__info--type'>
                                {guest.PatientType}
                            </div>
                        }
                        <div
                            className='guest__info--room'
                            style={guest.Room === 'Pre-Order' ? {'color' : '#ff0000'} : {}}>
                            {selectedLocation.POSShowRooms ? guest.Room : ''}
                        </div>
                        <div className='guest__info--register'>
                            {guest.Register} {selectedLocation.POSStatus ? '('+(guest.IsPaid ? 'Paid' : 'Unpaid')+')' : ''}
                        </div>
                    </div>

                    <div className='guest__info--timestamp'>
                        {moment.utc(guest.CheckInDateUTC).local().format('D MMM - h:mm A')}
                    </div>

                    <Timer
                        timestamp={guest.CheckInDateUTC} />

                    <div
                        className='guest__info--cart'
                        title={guest.TotalItems+' items in cart'}>
                        { selectedLocation.POSStatus ? guest.TransactionStatus : '' }&nbsp;&nbsp;
                        <i className='fa fa-shopping-cart' aria-hidden='true' /> <span>{guest.TotalItems}{preOrderCnt}</span>
                        { wholeSale &&
                            <span>- ${guest.OrderTotal}</span>
                        }
                    </div>

                </div>

                <ul
                    className='guest__controls'
                    id={'control_'+this.state.uuid}>

                    <Select
                        guest={guest}
                        selected={selected}
                        clearSelected={() => { this.props.onClick(false) }}
                        lsp={lsp} />

                    <Release
                        guest={guest} />

                    <CheckoutButton
                        guest={guest} />

                    <ViewProfile
                        guest={guest}
                        user={user}  />

                    <li>
                        <div
                            className={'btn-green'}
                            onClick={() => { PopupActions.patientJournal(guest); }}>

                            JOURNAL
                        </div>
                    </li>

                    { selectedLocation.POSShowRooms &&
                        <li>
                            <div
                                className={'btn-green'}
                                onClick={() => { PopupActions.open('change-room', false, guest); }}>

                                ROOM
                            </div>
                        </li>
                    }

                    { selectedLocation.POSStatus &&
                        <li>
                            <div
                                className={'btn-green'}
                                onClick={() => { PopupActions.open('change-status', false, guest); }}>

                                STATUS
                            </div>
                        </li>
                    }
                </ul>
            </div>
        );
    }
}

export default Guest;


/*




*/


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/Guest.react.jsx